import React from 'react';
import './style.css';

import FilterNews from '../../components/FilterNews';
import NewsGrid from '../../components/NewsGrid';
import { Helmet } from 'react-helmet';
import {
    BannerNews
} from '../../assets/images';

class News extends React.Component {
  render() {
    return (
      <>
        <Helmet>
            <meta charSet='utf-8' />
            <title>Noticias| Frijoles Isadora</title>
            <meta name="description" content="Noticias sobre Frijoles Isadora" />             
            <link rel='canonical' href={window.location.href} />
            <style type='text/css'>
                {`
                    .sr-only {
                        position: absolute;
                        width: 1px;
                        height: 1px;
                        padding: 0;
                        margin: -1px;
                        overflow: hidden;
                        clip: rect(0, 0, 0, 0);
                        white-space: nowrap;
                        border-width: 0;
                    }
                    
                `}
            </style>
        </Helmet>
        <h1 className="sr-only">Noticias</h1>
       <section id='News' className='alx-back-seccion'>
            <div className='container'>
                <div className='row'>

                    <div className="col-xs-12 col-md-12 col-lg-9" id="alx-div-banner-home-noticias">
                        <div className="alx-banner">
                           <img
                              src={BannerNews}
                              alt="News Isadora México"
                              className='alx-img-full'
                          />
                        </div>
                    </div>
                    <div className="col-xs-12 col-md-12 col-lg-3">
                        <FilterNews />
                    </div>
                    
                </div>
            </div>
            <div className='container'>
                <div className='row'>
                    <div className="col-xs-12 col-md-12 col-lg-9">
                        <NewsGrid />
                    </div>
                    <div className="col-xs-12 col-md-12 col-lg-3">
                    </div>
                </div>
            </div>

        </section>
      </>
    )
  }
}

export default News;